/**
 * Flooded / Violet-Blue-Green.
 */ var VioletBlueGreen = [
    /**
     * Green Props.
     */ {
        variant: 'green',
        size: '985',
        rotate: 130,
        blur: 21.3,
        x: '892',
        y: '-360'
    },
    /**
     * Blue Props.
     */ {
        variant: 'blue',
        size: '1176',
        rotate: 50,
        blur: 21.3,
        x: '131',
        y: '132'
    },
    /**
     * Violet Props.
     */ {
        variant: 'violet',
        size: '1206',
        rotate: -130,
        blur: 19.3,
        x: '-388',
        y: '421'
    }
];

export { VioletBlueGreen as default };
//# sourceMappingURL=violet-blue-green.es.js.map
